import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-platforms-login',
  templateUrl: './platforms-login.component.html',
  styleUrls: ['./platforms-login.component.scss']
})
export class PlatformsLoginComponent {
  constructor(
    private readonly router: Router
  ) { }

  public oauth2LoginRedirect(provider:string) {
    window.location.href = environment.url + '/oauth2/authorization/' + provider;
  }


}
